<template>
    <div>
        <div class="ai-list-page-content">
            <div class="pa-4">
                <h1>Нейросети</h1>
            </div>

            <v-row class="pa-4" dense>
                <v-col v-for="item in items" :key="item.id" cols="12" sm="6" md="4">
                    <CardUI @click.native="openLink(item)">
                        <template v-slot:body>
                            <h4> <v-icon>mdi-robot</v-icon> {{ item.title }}</h4>
                            <p class="mt-2 mb-0">
                                {{ item.description.slice(0, 256) }}...
                            </p>
                        </template>

                        <template v-slot:footer v-if="$store.state.user.currentUser.admin">
                            <div>
                                <v-icon x-small class="mr-1">mdi-cursor-default-click</v-icon>
                                {{ item.clicks }} переходов
                            </div>
                            <v-spacer/>
                        </template>
                    </CardUI>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import ai from "@/api/ai_links.js";
import CardUI from "@/components/UI/CardUI.vue"; 

export default {
    name: "AIList",
    components: {CardUI},
    data() {
        return {
            items: [],
            loading: true,
        };
    },

    mounted() {
        ai.all().then((r) => {
            this.items = r.data;
            this.loading = false;
        });
    },
    methods: {
    openLink(item) {
        ai.click(item).then(() => {
            item.clicks++;
        });
        window.open(item.url, '_blank');
    }
}
};
</script>

<style scoped>
.ai-list-page-content {
    max-width: 986px;
    background: white;
    padding: 20px;
    border-radius: 20px;
    margin: 20px auto 0;
}
</style>